export const STORE_URLS = {
  googlePlay: "https://play.google.com/store/apps/details?id=com.alphapulse.omegavitality&hl=en-US",
  appStore: "https://apps.apple.com/us/app/alphapulse-fitness/id6751271270",
};

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_fitness-hub-preview-3/artifacts/67vzdqfj_AlphaPulse%20Logo%20-%20Revised%20-%20Resized%20-%20May%2022%2C%202025%20-%20Resized%20for%20Google.png",
  qr: "https://customer-assets.emergentagent.com/job_fitness-hub-preview-3/artifacts/onvrop38_Alpha%20Omega%20Vitality%20APP%20-%20Get%20It%20On%20Google%20Play%20%26%20Download%20on%20Apple%20Store%20-%20QR%20Code.png",
  hero: "https://images.unsplash.com/photo-1726195221456-7e104a23bbff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxydW5uaW5nJTIwdHJhY2slMjBuaWdodHxlbnwwfHx8fDE3ODI3NTk3MTd8MA&ixlib=rb-4.1.0&q=85",
  workout: "https://images.unsplash.com/photo-1676655079738-af54dfd6318e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxhdGhsZXRlJTIwbGlmdGluZyUyMHdlaWdodHMlMjBkYXJrfGVufDB8fHx8MTc4Mjc1OTcxN3ww&ixlib=rb-4.1.0&q=85",
  nutrition: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwZnJlc2glMjBzYWxhZCUyMGJvd2x8ZW58MHx8fHwxNzgyNzU5NzE3fDA&ixlib=rb-4.1.0&q=85",
  community: "https://images.unsplash.com/photo-1731325632701-90d4e869a98e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwZ3JvdXAlMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODI3NTk3MTd8MA&ixlib=rb-4.1.0&q=85",
  recipes: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxoZWFsdGh5JTIwZnJlc2glMjBzYWxhZCUyMGJvd2x8ZW58MHx8fHwxNzgyNzU5NzE3fDA&ixlib=rb-4.1.0&q=85",
  equipment: "https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxhdGhsZXRlJTIwbGlmdGluZyUyMHdlaWdodHMlMjBkYXJrfGVufDB8fHx8MTc4Mjc1OTcxN3ww&ixlib=rb-4.1.0&q=85",
  gym: "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwZ3ltJTIwc3RyZW5ndGglMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODI3NTk4MDZ8MA&ixlib=rb-4.1.0&q=85",
  appPhone: "https://images.unsplash.com/photo-1608138279038-8dd61d909bd0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxmaXRuZXNzJTIwYXBwJTIwc21hcnRwaG9uZSUyMHdvcmtvdXR8ZW58MHx8fHwxNzgyNzU5ODA2fDA&ixlib=rb-4.1.0&q=85",
};

export const AVATARS = {
  jasmine: "https://images.unsplash.com/photo-1609371497456-3a55a205d5eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxhdGhsZXRpYyUyMHBlcnNvbiUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgyNzU5ODA2fDA&ixlib=rb-4.1.0&q=85",
  chris: "https://images.unsplash.com/photo-1606335544053-c43609e6155d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxhdGhsZXRpYyUyMHBlcnNvbiUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgyNzU5ODA2fDA&ixlib=rb-4.1.0&q=85",
  tariq: "https://images.unsplash.com/photo-1516224498413-84ecf3a1e7fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxhdGhsZXRpYyUyMHBlcnNvbiUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgyNzU5ODA2fDA&ixlib=rb-4.1.0&q=85",
  samantha: "https://images.unsplash.com/photo-1610903866883-c280999dcc0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxhdGhsZXRpYyUyMHBlcnNvbiUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgyNzU5ODA2fDA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Features", href: "#features" },
  { label: "Analytics", href: "#analytics" },
  { label: "Community", href: "#community" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const PILLARS = [
  {
    icon: "Dumbbell",
    title: "Exercise Library",
    desc: "Expert-led exercises with HD instructional videos, smart filtering and modifications for every level.",
  },
  {
    icon: "Apple",
    title: "Nutrition Library",
    desc: "Macro tracking, meal planning, barcode scanning and a vast food database to fuel your goals.",
  },
  {
    icon: "Users",
    title: "Community",
    desc: "Challenges, a social feed and built-in messaging so you never train alone.",
  },
  {
    icon: "LineChart",
    title: "Analytics",
    desc: "Dynamic charts for weight, strength and measurements with weekly progress reports.",
  },
  {
    icon: "Sparkles",
    title: "Personalized Plans",
    desc: "Adaptive training programs that evolve with your progress toward weight loss, muscle or endurance.",
  },
];

export const FEATURES = [
  { icon: "Dumbbell", title: "Complete Exercise Library", desc: "HD instructional videos for every movement." },
  { icon: "CalendarDays", title: "Adaptive Workout Plans", desc: "Programs that evolve as you get stronger." },
  { icon: "Utensils", title: "Nutrition & Meal Planning", desc: "Macros, hydration and smart meal logging." },
  { icon: "BookOpen", title: "Healthy Recipe Library", desc: "Goal-based recipes delivered every month." },
  { icon: "Activity", title: "Progress Analytics", desc: "Track strength, weight and body trends." },
  { icon: "Bell", title: "Smart Reminders", desc: "Build consistent habits that stick." },
];

export const TESTIMONIALS = [
  {
    quote: "Finally — an app that does it all.",
    body: "I've tried every fitness app out there, but this one actually keeps me consistent. The workout videos are super clear, and the meal plans make eating healthy feel easy. I'm down 12 pounds and counting!",
    name: "Jasmine L.",
    role: "31 · Busy Professional",
    avatar: "jasmine",
  },
  {
    quote: "Built for real progress — not gimmicks.",
    body: "The tracking features are next level. I love seeing my strength gains charted over time. And the social challenges keep me pushing harder each week. It feels like a personal trainer in my pocket.",
    name: "Chris D.",
    role: "27 · Gym Enthusiast",
    avatar: "chris",
  },
  {
    quote: "Love the nutrition features!",
    body: "I didn't realize how off my eating was until I started logging my meals. Now I follow a plan that works with my lifestyle, and I feel more energized than ever. The barcode scanner is a game-changer.",
    name: "Tariq A.",
    role: "35 · Plant-Based Runner",
    avatar: "tariq",
  },
  {
    quote: "A true all-in-one fitness companion.",
    body: "From workouts to food to expert support — this app has it all. I use it every day, and it just keeps getting better. It's like having a coach, a nutritionist and a whole community in one place.",
    name: "Samantha G.",
    role: "29 · Coach & Creator",
    avatar: "samantha",
  },
];

export const PLANS = [
  {
    name: "Starter",
    price: "$0",
    period: "forever",
    tagline: "Get moving for free",
    highlight: false,
    features: [
      "Core exercise library access",
      "Basic workout logging",
      "Community feed & challenges",
      "Habit reminders",
    ],
    cta: "Start Free",
  },
  {
    name: "Premium",
    price: "$12.99",
    period: "/ month",
    tagline: "Everything, monthly",
    highlight: true,
    features: [
      "Full HD video library",
      "Personalized adaptive plans",
      "Advanced nutrition & macros",
      "Progress analytics & badges",
      "25% off all vitamins & supplements",
      "Priority coaching support",
    ],
    cta: "Go Premium",
  },
  {
    name: "Annual",
    price: "$89.99",
    period: "/ year",
    tagline: "Best value · save 42%",
    highlight: false,
    features: [
      "Everything in Premium",
      "2 months free vs monthly",
      "25% off all vitamins & supplements",
      "Exclusive monthly meal plans",
    ],
    cta: "Get Annual",
  },
];

export const FAQS = [
  {
    q: "Is AlphaPulse free to start?",
    a: "Yes. The Starter plan is free forever and includes the core exercise library, workout logging and community access. Upgrade to Premium any time for advanced features.",
  },
  {
    q: "Can I train at home and at the gym?",
    a: "Absolutely. AlphaPulse adapts routines to your equipment and schedule, with programs designed for both home and gym training across every fitness level.",
  },
  {
    q: "Does it track nutrition and macros?",
    a: "Yes. Log meals, track macros, scan barcodes from a huge food database and follow personalized meal plans for goals like weight loss, muscle gain or balanced eating.",
  },
  {
    q: "Will my data sync across devices?",
    a: "Your workouts, nutrition and progress sync securely to the cloud so your data is always available across your phone, tablet and other devices.",
  },
  {
    q: "What do I get with Premium?",
    a: "Premium unlocks the full HD video library, adaptive personalized plans, advanced analytics, and 25% off all vitamins & supplements at AlphaOmegaVitality.com on the annual plan.",
  },
];
